import { Types } from "../actions/TechnicianMainPageActions";

const initialState = {
    unplannedActiveCounts: {},
    plannedActiveCounts: {},
    notifications: {},
    barCodeInfo: {},
};

export const TechnicianMainPageReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_UNPLANNED_MAINTENANCE_ACTIVE_COUNTS:
            return {
                ...state,
                unplannedActiveCounts: action.payload || state.unplannedActiveCounts,
            };

        case Types.SET_PLANNED_MAINTENANCE_ACTIVE_COUNTS:
            return {
                ...state,
                plannedActiveCounts: action.payload || state.plannedActiveCounts,
            };

        case Types.SET_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.payload || state.notifications,
            };

        case Types.SET_BARCODE_CONTENT:
            return {
                ...state,
                barCodeInfo: action.payload || state.barCodeInfo,
            };

        default:
            return state;
    }
};
